import { useToggle } from '@healthhub/react-ui';
import { Dropdown } from 'antd';
import type { DropdownProps } from 'antd';
import { useCallback } from 'react';

import { OutlinedRightIcon } from '@shared/assets-icon';

import AccountSettingsDropdownPopup from './AccountSettingsDropdownPopup';

interface AccountSettingsDropdownProps extends Pick<DropdownProps, 'menu'> {
  header: string;
}

const AccountSettingsDropdown = ({ menu, header }: AccountSettingsDropdownProps) => {
  const [openDropdown, toggleDropdown] = useToggle();

  const renderPopup = useCallback(
    (nodes: React.ReactNode) => (
      <AccountSettingsDropdownPopup header={header} menu={nodes} toggleDropdown={toggleDropdown} />
    ),
    [header, toggleDropdown]
  );

  return (
    <Dropdown
      align={{
        points: ['tr', 'tr'],
        offset: [0, 0],
      }}
      menu={menu}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          toggleDropdown();
        }
      }}
      open={openDropdown}
      popupRender={renderPopup}
      trigger={['click']}
    >
      <button
        className="flex self-start whitespace-nowrap flex-row items-center justify-center text-primary-green-4 text-sm font-semibold gap-1"
        onClick={() => toggleDropdown()}
        type="button"
      >
        {header} <OutlinedRightIcon className="rotate-90 size-4" />
      </button>
    </Dropdown>
  );
};

export default AccountSettingsDropdown;
